/* eslint-disable fp/no-mutation */
/* eslint-disable fp/no-mutating-methods */
import { ReactElement, useEffect, useState } from 'react'

import Alert from '@mui/material/Alert'
import Avatar from '@mui/material/Avatar'
import Snackbar from '@mui/material/Snackbar'
import Typography from '@mui/material/Typography'
import { CertificateIcon } from 'src/v3/core/icons'

import theme from 'src/theme'
import { useAppDispatch, useAppSelector } from 'src/store/hooks'
import {
  fetchCertificates,
  selectCertificates,
  selectCertificatesStatus,
  fetchLiveCertificates,
  selectLiveCertificates,
  selectLiveCertificatesStatus,
  fetchExternalCertificates,
  selectExternalCertificates,
  selectExternalCertificatesStatus,
} from 'src/v3/profile/profile.slice'
import Subheader from 'src/v3/components/subheader'
import {
  CertificateList,
  ExternalCertificateList,
} from 'src/v3/components/certificate-list'
import Loading from 'src/v3/components/loading'

export default (): ReactElement => {
  let dispatch = useAppDispatch()

  let recordedCertificatesStatus = useAppSelector(selectCertificatesStatus)
  let recordedCertificates = useAppSelector(selectCertificates)
  let liveCertificatesStatus = useAppSelector(selectLiveCertificatesStatus)
  let liveCertificates = useAppSelector(selectLiveCertificates)
  let externalCertificatesStatus = useAppSelector(
    selectExternalCertificatesStatus,
  )
  let externalCertificates = useAppSelector(selectExternalCertificates)

  let [errorMessage, setErrorMessage] = useState<string>('')

  useEffect(() => {
    if (recordedCertificatesStatus === 'uninitialized') {
      dispatch(fetchCertificates())
    }
  }, [recordedCertificatesStatus])

  useEffect(() => {
    if (liveCertificatesStatus === 'uninitialized') {
      dispatch(fetchLiveCertificates())
    }
  }, [liveCertificatesStatus])

  useEffect(() => {
    if (externalCertificatesStatus === 'uninitialized') {
      dispatch(fetchExternalCertificates())
    }
  }, [externalCertificatesStatus])

  return (
    <>
      <div className="flex items-center justify-center my-2">
        <Avatar sx={{ bgcolor: theme.palette.primary.main }}>
          <CertificateIcon />
        </Avatar>
        <Typography
          variant="h4"
          className="pl-2"
          style={{
            fontFamily: 'smileAndWave',
          }}
        >
          Certificates
        </Typography>
      </div>
      <Typography
        textAlign="center"
        color="text.secondary"
        sx={{ marginBottom: -1 }}
      >
        View and manage your recorded, live, and external certificates
      </Typography>
      <Subheader title="Recorded Certificates" />
      <CertificateList
        certificates={recordedCertificates}
        certificateType="Recorded"
        setErrorMessage={setErrorMessage}
        domain="profile"
      />
      <Subheader title="Live Certificates" />
      <CertificateList
        certificates={liveCertificates}
        certificateType="Live"
        setErrorMessage={setErrorMessage}
        domain="profile"
      />
      <Subheader title="External Certificates" />
      <ExternalCertificateList
        certificates={externalCertificates}
        fetchCertificates={fetchExternalCertificates as any}
        setErrorMessage={setErrorMessage}
      />
      <Snackbar open={!!errorMessage} onClose={() => setErrorMessage('')}>
        <Alert
          variant="filled"
          onClose={() => setErrorMessage('')}
          severity="error"
        >
          {errorMessage}
        </Alert>
      </Snackbar>
      <Loading
        entities={[
          externalCertificatesStatus,
          liveCertificatesStatus,
          recordedCertificatesStatus,
        ]}
      />
    </>
  )
}
